import React, { useState, useEffect } from "react";
import { Typography, Grid2 } from "@mui/material";
import Divider from "@mui/material/Divider";
import AppButton from "../../components/CommonReusableComponent/AppButton/AppButton";
import AppInputField from "../../components/CommonReusableComponent/AppInputField/AppInputField";
import MUILoader from "../../components/MUILoader/MUILoader";
import MUITableSearch from "../../components/MUITable/MUITableSearch";
// components
import DepartmentMasterDataTable from "./components/DepartmentMasterDataTable";
import CreateNewOrUpdateDepartmentModal from "./components/CreateNewOrUpdateDepartmentModal";
import DeleteDepartmentConfirmationModal from "./components/DeleteDepartmentConfirmationModal";
import { departmentMasterColumnsData } from "./components/DepartmentMaster.config";
import { handleOutSideDataTableSearch } from "../../common/MuiTableFunctions.config";
import { useSnackbar } from "../../contexts/Snackbar.context";
import {
  APP_MESSAGE,
  ERROR_MESSAGE,
  SNACKBAR_VARIANT,
} from "../../config/Messages.config";
import {
  deleteDepartment,
  getAllDepartmentListByBranchId,
} from "../../helpers/api-functions-helper";
import {
  getUserRoleAndScreens,
} from "../../services/authServices/auth.services";
import { getDataForAllOption, getPageTitle, setRequiredDataForDropdown } from "../../common/CommonFunctions";
import DepartmentMasterDataTable_V2 from "./components/DepartmentMasterDataTable_V2";
import { ROLES } from "../../config/Roles.config";
import AppAutoCompleteField from "../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";

const DepartmentMaster = () => {
  const documentTitle = getPageTitle() && getPageTitle();
  document.title = documentTitle ? `${documentTitle} | Zing Auditor` : "Zing Auditor"
  const authUser = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
  );
  const { showSnackbar } = useSnackbar();
  const { assignedBranches, accountId, role } = getUserRoleAndScreens();
  const [isTableDataLoading, setIsTableDataLoading] = useState(false);
  const [selectPlant, setSelectPlant] = useState(null);
  const [allPlants, setAllPlants] = useState([]);
  const [tableDataInstance, setTableDataInstance] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [toggleCreateOrUpdateModal, setToggleCreateOrUpdateModal] =
    useState(false);
  const [toggleDeleteModal, setToggleDeleteModal] = useState(false);
  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  const [modalDataState, setModalDataState] = useState(null);

  // search functionality
  const [searchText, setSearchText] = useState("");

  // All Object for selection
  const allObjWithNameId = [{ name: "All", id: "All" }];
  // const allObjWithLabelValue = [{ label: "All", value: "All" }];

  const is_SuperAdmin =
      role && role.toLowerCase() === ROLES.SUPERADMIN ? true : false;

  // Fetch all plants
  const fetchAllBranches = () => {
    const hasMultipleBranches = assignedBranches?.length > 1;
    const hasBranches = assignedBranches?.length > 0;

    const dataSet = is_SuperAdmin && hasMultipleBranches
    ? [...allObjWithNameId, ...assignedBranches]
    : assignedBranches || [];
    
    setRequiredDataForDropdown(setAllPlants, dataSet, "name", "id", ["isActive"]);

    const defaultPlantId =
      is_SuperAdmin && hasMultipleBranches
        ? "All"
        : hasBranches
        ? assignedBranches[0].id
        : null;

    setSelectPlant(defaultPlantId);
  };

  // Fetch all user of a plant/project
  const fetchAllDepartmentByBranchId = (branchId) => {
    const payload = {
      branchIds: getDataForAllOption("branch", branchId, allPlants),
      accountId: accountId,
    };
    setIsTableDataLoading(true);
    getAllDepartmentListByBranchId(payload)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data, message } = response.data;
          if (statusCode && statusCode === 200) {
            // console.log("data: ", response.data);
            const formatted_data =
              data && data?.length > 0
                ? data.map((dept) => {
                    return {
                      ...dept,
                      departmentInchargeListForDataTable:
                        dept.departmentInchargeList
                          ?.map((incharge) => incharge.departmentInchargeName)
                          .join(", "),
                    };
                  })
                : [];
            setTableDataInstance(formatted_data);
            setTableData(formatted_data);
          } else {
            showSnackbar(message, SNACKBAR_VARIANT.ERROR);
            setTableDataInstance(data);
            setTableData(data);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsTableDataLoading(false);
      });
  };

  // Function used toggle modal on their types
  const handleToggleModal = (modalType) => {
    if (modalType === "Create/Update") {
      setToggleCreateOrUpdateModal((e) => !e);
    } else {
      setToggleDeleteModal((e) => !e);
    }
  };

  const getRowDataOnClickOfAction = (actionName, data) => {
    if (actionName === "Update Department") {
      setModalDataState(data);
      handleToggleModal("Create/Update");
    } else if (actionName === "Create Department") {
      handleToggleModal("Create/Update");
    } else {
      setModalDataState(data);
      handleToggleModal("Delete Department");
    }
  };

  const deleteExistingDepartment = () => {
    setIsDeleteClicked(true);
    deleteDepartment({
      updatedBy: authUser.uid,
      departmentId: modalDataState?.id,
      accountId: accountId,
    })
      .then((res) => {
        if (res && res.data) {
          // console.log(res.data);
          const { statusCode, success } = res.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              APP_MESSAGE.LOCATION_MASTER.DELETE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.LOCATION_MASTER.DELETE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            handleToggleModal("Delete Location");
            setModalDataState(null);
            fetchAllDepartmentByBranchId(selectPlant);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.HOLIDAY_MASTER.DELETE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setIsDeleteClicked(false);
      });
  };

  // const handleChangeBranch = (event) => {
  //   const { value } = event.target;
  //   setSelectPlant(value);
  // };
  const handleChangeBranch = (Data) => {
    setSelectPlant(Data?.value || null);
  };

  useEffect(() => {
    if (navigator.onLine) {
      if (selectPlant) {
        fetchAllDepartmentByBranchId(selectPlant);
      }
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectPlant]);

  useEffect(() => {
    fetchAllBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Outside Table search functionality
  useEffect(() => {
    if (searchText === "") {
      // Reset to original data if search text is cleared
      setTableData(tableDataInstance);
    } else {
      const filteredData_ = handleOutSideDataTableSearch(
        searchText,
        tableDataInstance
      );
      setTableData(filteredData_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <React.Fragment>
      {toggleCreateOrUpdateModal ? (
        <CreateNewOrUpdateDepartmentModal
          ListOfAllBranches={allPlants || []}
          Open={toggleCreateOrUpdateModal}
          Title={modalDataState ? "Update Existing Department" : "Create New Department In The Branch"}
          DialogData={modalDataState}
          SetDialogData={setModalDataState}
          ToggleDialogBox={handleToggleModal}
          FetchAllDepartmentByBranchId={fetchAllDepartmentByBranchId}
          CurrentBranchId={selectPlant}
          AllDepartmentNames={
            tableDataInstance[0] &&
            tableDataInstance.map((dept) => dept.name.toLowerCase())
          }
        />
      ) : null}
      {toggleDeleteModal ? (
        <DeleteDepartmentConfirmationModal
          ModalState={toggleDeleteModal}
          SetModalState={setModalDataState}
          ToggleFunction={handleToggleModal}
          LoaderState={isDeleteClicked}
          OnSubmit={deleteExistingDepartment}
        />
      ) : null}
      <div className="page-content">
        <Grid2 container className="d-flex align-items-center my-1" spacing={2}>
          <Grid2 size={{xs: 12, sm: 4, md: 5, lg: 5}} className="py-1">
            <Typography className="inter-medium-500">
              {documentTitle}
            </Typography>
          </Grid2>
          <Grid2 size={{xs: 12, sm: 5, md: 4, lg: 4}} className="py-1">
            {/* <AppInputField
              IsSelect={true}
              Name={"selectPlant"}
              Id={"selectPlant"}
              Value={selectPlant}
              SelectOptions={allPlants || []}
              Label={"Select branch"}
              OnChange={handleChangeBranch}
            /> */}
            <AppAutoCompleteField
              IsMultiple={false}
              Id={"selectPlant"}
              TextInputName={"selectPlant"}
              Value={selectPlant}
              Options={allPlants || []}
              TextInputLabel={"Select branch"}
              TextInputPlaceholder={"Select branch"}
              HandleOnChange={(event, value) => {
                handleChangeBranch(value);
              }}
            />
          </Grid2>
          <Grid2 size={{xs: 12, sm: 3, md: 3, lg: 3}} className="py-1">
            <AppButton OnPress={() => handleToggleModal("Create/Update")}>
              Create New Department
            </AppButton>
          </Grid2>
        </Grid2>
        <Divider
          style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
          className="mt-2"
        />
        {!isTableDataLoading ? (
          <Grid2 container className="my-2" spacing={2}>
            <Grid2 size={{xs: 12, sm: 4, md: 4, lg: 4}}>
              <MUITableSearch
                CancelSearch={() => {
                  setSearchText("");
                }}
                HandleSearch={(e) => setSearchText(e.target.value)}
                SearchText={searchText}
              />
            </Grid2>
          </Grid2>
        ) : null}

        <Grid2 container className="d-flex align-items-center my-2">
          <Grid2 size={{xs: 12, sm: 12, md: 12, lg: 12}}>
            {isTableDataLoading ? (
              <MUILoader />
            ) : (
              // <DepartmentMasterDataTable
              //   Columns={departmentMasterColumnsData}
              //   DenseTable={true}
              //   IsOutSideSearch={true}
              //   GetRowDataOnClickOfEditIcon={(actionName, data) => {
              //     getRowDataOnClickOfAction(actionName, data);
              //   }}
              //   RowsToDisplay={10}
              //   RowData={tableData || []}
              //   OptionsForRowsPerPage={[5, 10, 15, 25, 50]}
              // />
              <DepartmentMasterDataTable_V2 
                Rows={tableData || []}
                GetRowDataOnClickOfAction={getRowDataOnClickOfAction}
              />
            )}
          </Grid2>
        </Grid2>
      </div>
    </React.Fragment>
  );
};

export default DepartmentMaster;
